module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1232.28399f36.png";